import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { ExpRegSoloNumeros } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { getSearchUsuariosService } from '../../usuarios/UsuariosService';
import { saveUsuEntidadesAction } from '../UsuEntidadesAction';

const AsignarUsuarioEntidad = ({ setOpenModalForm = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const [dni, setDNI] = React.useState('');
  const [usuario, setUsuario] = React.useState(null);
  const [loadingSearch, setLoadingSearch] = React.useState(false);
  const [loadingSave, setLoadingSave] = React.useState(false);

  const card = () => {
    return (
      <Card>
        <CardContent sx={{ p: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <Avatar
              alt={usuario.perfil.pnombre}
              src={
                usuario.perfil.avatar
                  ? getFilesArchivos(usuario.perfil.avatar)
                  : `static/images/${
                      usuario.perfil.gender ? 'userf.png' : 'userm.png'
                    }`
              }
              sx={{ width: 100, height: 100, mr: 2 }}
            />
            <Typography sx={{ fontWeight: 'bold', fontSize: '14pt' }}>
              {usuario.perfil.tipoDni}-{usuario.perfil.dni}
              <br />
              {usuario.perfil.pnombre} {usuario.perfil.papellido}
              <br />
              {usuario.perfil.snombre} {usuario.perfil.sapellido}
            </Typography>
          </Box>
        </CardContent>
        <CardActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <BotonComponent
            text="asignar"
            loading={loadingSave}
            click={async () => {
              setLoadingSave(true);
              await saveUsuEntidadesAction(
                { dispatch, notify, user: loginStore.user },
                {
                  idEntidad: entidadesStore.activo.id,
                  idUsuario: usuario.id,
                  isInvitado: true,
                },
                {
                  idEntidad: entidadesStore.activo.id,
                  ...usuEntidadesStore.params,
                },
              );
              setDNI('');
              setUsuario(null);
              setLoadingSave(false);
              setOpenModalForm(false);
            }}
            green
          />
          <BotonComponent
            text="descartar"
            click={() => {
              setDNI('');
              setUsuario(null);
            }}
            red
          />
        </CardActions>
      </Card>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={12}
        flexDirection="row"
        display="flex"
        alignItems="flex-start"
      >
        <TextField
          fullWidth
          size="small"
          id={CONST.dni.name}
          required
          label={CONST.dni.label}
          value={dni}
          onChange={(e) => {
            const { value } = e.target;
            const isValid =
              value.match(ExpRegSoloNumeros) !== null &&
              (value === '' || value.length < 10);

            if (isValid) {
              setDNI(value);
            } else {
              setDNI(value.slice(0, -1));
            }

            setUsuario(null);
          }}
        />
        <BotonComponent
          click={async () => {
            setLoadingSearch(true);
            const res = await getSearchUsuariosService({ q: dni });
            if (res.data.data.length > 0) {
              setUsuario(res.data.data[0]);
            } else {
              notify(res.data.message, { error: true });
            }
            setLoadingSearch(false);
          }}
          blue
          loading={loadingSearch}
          disabled={dni === '' || !dni || dni.length < 7}
          size="large"
          ml={1}
          searchIcon
          text="BUSCAR"
        />
      </Grid>
      <Grid item xs={12} md={12}>
        {usuario && card()}
      </Grid>
    </Grid>
  );
};

export default AsignarUsuarioEntidad;
